@let title = challenge().productScope.label[shortLocale];
<div class="card" [id]="challenge().offerId">
  <div
    class="un-card-header"
    [style.height]="config().header.height"
    [style.backgroundColor]="config().header.backgroundColor"
  >
    <!-- Banner -->
    @if (challenge().hasBanner()) {
      <div class="banner">
        @if (loadBannerInPriority()) {
          <img
            fill
            priority
            class="img responsive-width"
            [alt]="config().bannerAlternativeText"
            [ngSrc]="challenge().productScope.bannerPath!"
          />
        } @else {
          <img
            fill
            class="img responsive-width"
            [alt]="config().bannerAlternativeText"
            [ngSrc]="challenge().productScope.bannerPath!"
          />
        }
      </div>
    }

    <!-- Logo -->
    @if (!challenge().hasBanner()) {
      <div class="logo-container">
        <div class="box">
          <img
            class="logo"
            [alt]="config().logoAlternativeText"
            [src]="challenge().productScope.logoPath"
          />
        </div>
      </div>
    }
  </div>

  <!-- SubHeader -->
  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.color]="config().subHeader.color"
    [style.fontSize]="config().subHeader.fontSize"
    [style.fontFamily]="config().subHeader.fontFamily"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    <p
      class="label"
      b2cTooltipIfTruncated
      [b2cTooltipHideDelay]="80"
      [b2cTooltipShowDelay]="120"
      [b2cTooltipPosition]="'above'"
      [b2cTooltip]="title.toString()"
    >
      {{ title }}
    </p>
  </div>

  <div class="bottom">
    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card
        class="win-container"
        [amount]="challenge().maxPotentialReward"
      />
    } @else {
      <div class="card-content">
        <b2c-progress-section
          [config]="config()"
          [challenge]="challenge()"
          [class.one-two-steps]="challenge().targets.length < 3"
        />
      </div>

      <div
        class="card-footer"
        [style.backgroundColor]="config().footer.backgroundColor"
      >
        <div class="footer">
          @if (challenge().progress > 0) {
            <p
              class="label"
              [style.color]="config().footer.totalSpent.color"
              [style.fontFamily]="config().footer.totalSpent.fontFamily"
            >
              {{ config().footer.totalSpent.label }}:
            </p>
            <div
              class="amount-spent"
              [style.fontFamily]="
                config().footer.totalSpent.spentAmountFontFamily
              "
            >
              {{ challenge().progress | formatAmount: 'currency' }}
            </div>
          } @else {
            <b2c-unselection-button
              [phase]="phase()"
              [challenge]="challenge()"
              class="unselect-text"
              [isBisCampaign]="isBisCampaign()"
              [isEventChallenge]="isEventChallenge()"
            />
          }
        </div>

        <!-- Eligible Products -->
        <button
          b2cElement
          modalType="scanner"
          type="button"
          class="eligible-products"
          data-cy="check_product_btn"
          (click)="displayDialog(challenge(), title.toString())"
        >
          <p
            class="eligible-products-text"
            [style.color]="config().footer.eligibleProductLabel.color"
            [style.fontFamily]="config().footer.eligibleProductLabel.fontFamily"
          >
            {{ config().footer.eligibleProductLabel.label }}
          </p>
        </button>
      </div>
    }

    <!-- Selection Button -->
    @if (!challenge().isSelected) {
      <b2c-selection-button
        b2cElement
        [phase]="phase()"
        [challenge]="challenge()"
        class="selection-section"
        [isBisCampaign]="isBisCampaign()"
        [isEventChallenge]="isEventChallenge()"
      />
    }
  </div>
</div>
